import { render, staticRenderFns } from "./SelectCharacter.vue?vue&type=template&id=6565536f&scoped=true&"
import script from "./SelectCharacter.vue?vue&type=script&lang=ts&"
export * from "./SelectCharacter.vue?vue&type=script&lang=ts&"
import style0 from "./SelectCharacter.vue?vue&type=style&index=0&id=6565536f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6565536f",
  null
  
)

export default component.exports